import type {CreateAPITaskParams} from '@github-ui/agent-sessions/types/api-task'
import type {SelectedAgent} from '@github-ui/agent-sessions-types/agent-identity'
import type {DropdownRepository} from '@github-ui/one-copilot-composer/repository'
import type {HandleUserSubmitOptions} from '@github-ui/one-copilot-composer/user-submit'

export interface CreateTaskParamsContext {
  eventType: string
  /** When false, the task defaults to the 'fix' agent and creates a pull request. */
  taskModeEnabled?: boolean
}

/** Turns a composer submission into a cloud agent task request, or `null` when there is nothing to send. */
export function buildCreateTaskParams(
  {eventType, taskModeEnabled}: CreateTaskParamsContext,
  content: string,
  selectedRepo: DropdownRepository | null,
  selectedBranch: string,
  selectedAgent: SelectedAgent,
  modelId?: string,
  options?: HandleUserSubmitOptions,
): CreateAPITaskParams | null {
  const trimmedContent = content.trim()
  if (trimmedContent === '' || !selectedRepo) return null

  return {
    nwo: selectedRepo.nameWithOwner,
    problemStatement: trimmedContent,
    baseRef: selectedBranch || selectedRepo.defaultBranch,
    eventType,
    eventContent: trimmedContent,
    createPullRequest: options?.createPullRequest ?? (taskModeEnabled === false ? true : undefined),
    mcpPermissionMode: options?.mcpPermissionMode,
    model: modelId,
    reasoningEffort: options?.reasoningEffort,
    customAgent: selectedAgent?.subAgentSlug,
    agentId: selectedAgent?.topLevelAgentId,
  }
}
